// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Premium Contact Page Styles
   ========================================== */
   
:root {
  --primary-amber: #f59e0b;
  --primary-glow: rgba(245, 158, 11, 0.5);
  --bg-dark: #0f172a;
  --glass-bg: rgba(15, 23, 42, 0.55);
  --glass-border: rgba(255, 255, 255, 0.08);
  --text-main: #ffffff;
  --text-muted: #94a3b8;
}

/* Background & Page Wrapper */
.contact-page {
  position: relative;
  min-height: 100vh;
  padding: 7.25rem 1.5rem 4rem 1.5rem;
  background-color: var(--bg-dark);
  overflow: hidden;
  display: flex;
  justify-content: center;
}

/* Dynamic Background Orbs & Grid */
.bg-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  z-index: 0;
  opacity: 0.4;
  animation: float 12s infinite alternate ease-in-out;
}
.orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(245,158,11,0.2) 0%, transparent 70%);
  top: -10%;
  left: -10%;
}
.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%);
  bottom: 0;
  right: -5%;
  animation-duration: 15s;
  animation-direction: alternate-reverse;
}

.bg-grid {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
  background-size: 40px 40px;
  z-index: 0;
  pointer-events: none;
}

@keyframes float {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(30px, 40px) scale(1.05); }
}

/* Glassmorphism Container */
.contact-container {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  width: 100%;
  background: var(--glass-bg);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 24px;
  border: 1px solid var(--glass-border);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255,255,255,0.1);
  overflow: hidden;
}

/* Header */
.contact-header {
  padding: 4rem 2rem 2.5rem;
  text-align: center;
  position: relative;
}

.gradient-text {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #f59e0b 50%, #fbbf24 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
  letter-spacing: -0.04em;
  text-shadow: 0 10px 30px rgba(245,158,11,0.15);
}

.contact-header p {
  color: var(--text-muted);
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.7;
}

/* Layout */
.contact-content {
  display: flex;
  padding: 2rem 3rem 4rem;
  gap: 4rem;
  align-items: flex-start;
}

@media (max-width: 900px) {
  .contact-content {
    flex-direction: column;
    padding: 2rem 1.5rem 3rem;
    gap: 3rem;
  }
}

/* Left Panel - Info */
.contact-info {
  flex: 0.9 1;
  display: flex;
  flex-direction: column;
}

.contact-info h2 {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.contact-info > p {
  color: var(--text-muted);
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 2.5rem;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  padding: 1.25rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
  border: 1px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.contact-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(245, 158, 11, 0.2);
  transform: translateX(8px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.contact-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.05) 100%);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: var(--primary-amber);
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(245,158,11,0.1);
}

.contact-text h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.35rem;
}

.contact-text p {
  color: var(--text-muted);
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.6;
}

.contact-trust-card {
  margin-top: 0;
  background: linear-gradient(145deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 41, 59, 0.4) 100%);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  position: relative;
  overflow: hidden;
}

.contact-trust-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(245,158,11,0.05), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.contact-trust-card:hover::before {
  transform: translateX(100%);
}

.contact-trust-card .trust-icon {
  font-size: 1.5rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 70px;
  flex-shrink: 0;
  background: rgba(245, 158, 11, 0.2);
  border-radius: 16px;
  box-shadow: inset 0 0 10px rgba(245,158,11,0.1);
}

.contact-trust-card h4 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--primary-amber);
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
}

.contact-trust-card p {
  font-size: 0.95rem;
  color: #cbd5e1;
  margin: 0;
  line-height: 1.5;
}

.contact-trust-card strong {
  color: #ffffff;
  font-weight: 700;
}

/* Right Panel - Form Container */
.contact-form-container {
  flex: 1.1 1;
  background: rgba(255, 255, 255, 0.03);
  padding: 3rem;
  border-radius: 24px;
  border: 1px solid var(--glass-border);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255,255,255,0.05);
  position: relative;
}

.form-title {
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.form-subtitle {
  font-size: 0.95rem;
  color: var(--text-muted);
  margin-bottom: 2.5rem;
}

/* Floating Label Form Fields */
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: flex;
  gap: 1.5rem;
}

@media (max-width: 600px) {
  .form-row {
    flex-direction: column;
    gap: 1.5rem;
  }
}

.form-group.floating {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.form-group.floating input,
.form-group.floating textarea {
  width: 100%;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.25rem 1.25rem 0.5rem;
  font-size: 1rem;
  color: var(--text-main);
  font-family: inherit;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-group.floating textarea {
  padding-top: 1.75rem;
  resize: vertical;
}

.form-group.floating label {
  position: absolute;
  top: 1rem;
  left: 1.25rem;
  font-size: 1rem;
  color: var(--text-muted);
  pointer-events: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: left top;
}

.form-group.floating textarea ~ label {
  top: 1rem;
}

/* Floating Label Animation */
.form-group.floating input:focus ~ label,
.form-group.floating input:not(:placeholder-shown) ~ label,
.form-group.floating textarea:focus ~ label,
.form-group.floating textarea:not(:placeholder-shown) ~ label {
  transform: translateY(-0.5rem) scale(0.75);
  color: var(--primary-amber);
}

/* Animated Bottom Border */
.input-highlight {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  background: var(--primary-amber);
  transition: width 0.4s ease;
  border-radius: 0 0 12px 12px;
}

.form-group.floating input:focus ~ .input-highlight,
.form-group.floating textarea:focus ~ .input-highlight {
  width: 100%;
}

.form-group.floating input:focus,
.form-group.floating textarea:focus {
  outline: none;
  background: rgba(30, 41, 59, 0.8);
  border-color: rgba(255, 255, 255, 0.2);
}

.error-text {
  color: #ef4444;
  font-size: 0.85rem;
  margin-top: 0.5rem;
  font-weight: 500;
}

.input-error {
  border-color: rgba(239, 68, 68, 0.5) !important;
}

/* Checkbox Styles */
.checkbox-group {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  cursor: pointer;
}

.checkbox-container input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: var(--primary-amber);
  cursor: pointer;
  margin-top: 2px;
  flex-shrink: 0;
}

.checkbox-label {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
  cursor: pointer;
}

.checkbox-label strong {
  color: var(--text-main);
}

/* Premium Submit Button */
.submit-button {
  position: relative;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
  padding: 1.1rem 2rem;
  border-radius: 50px;
  font-size: 1.05rem;
  font-weight: 800;
  border: none;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.3);
  width: 100%;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.submit-button .btn-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.submit-button .btn-icon {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.5);
}

.submit-button:hover:not(:disabled) .btn-icon {
  transform: translate(3px, -3px);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Button Sweep Animation */
.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  transition: all 0.5s ease;
  z-index: 1;
}

.submit-button:hover:not(:disabled) .btn-glow {
  left: 100%;
}

/* Success Message */
.success-message {
  margin-top: 1.5rem;
  padding: 1rem 1.5rem;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #34d399;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.success-icon {
  background: #10b981;
  color: #0f172a;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 900;
}

/* FAQ Section */
.faq-section {
  padding: 4rem 3rem;
  border-top: 1px solid var(--glass-border);
  background: rgba(0, 0, 0, 0.1);
}

.faq-section h2 {
  text-align: center;
  font-size: 2rem;
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 3rem;
  letter-spacing: -0.02em;
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

@media (max-width: 768px) {
  .faq-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

.faq-item {
  background: rgba(255, 255, 255, 0.02);
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.hover-lift:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(245, 158, 11, 0.2);
  box-shadow: 0 15px 30px rgba(0,0,0,0.2);
}

.faq-item h3 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.75rem;
  line-height: 1.4;
}

.faq-item p {
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

/* Animations (Classes to add dynamically or just use on mount) */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInLeft {
  from { opacity: 0; transform: translateX(-40px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInRight {
  from { opacity: 0; transform: translateX(40px); }
  to { opacity: 1; transform: translateX(0); }
}

.fade-in-up { animation: fadeInUp 0.8s ease forwards; }
.fade-in-left { animation: fadeInLeft 0.8s ease forwards; }
.fade-in-right { animation: fadeInRight 0.8s ease forwards; }
.slide-up { animation: fadeInUp 0.4s ease forwards; }
`, "",{"version":3,"sources":["webpack://./src/Components/Contact.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;EACzC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,mDAAmD;AACrD;AACA;EACE,YAAY;EACZ,aAAa;EACb,6EAA6E;EAC7E,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,8EAA8E;EAC9E,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;uEAEqE;EACrE,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,KAAK,mCAAmC,EAAE;EAC1C,OAAO,4CAA4C,EAAE;AACvD;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,qCAAqC;EACrC,+EAA+E;EAC/E,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,uEAAuE;EACvE,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+FAA+F;EAC/F,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yFAAyF;EACzF,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,mFAAmF;EACnF,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,WAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;;EAEE,WAAW;EACX,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA,6BAA6B;AAC7B;;;;EAIE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,iEAAiE;AACjE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,cAAc,sCAAsC,EAAE;AACtD,gBAAgB,wCAAwC,EAAE;AAC1D,iBAAiB,yCAAyC,EAAE;AAC5D,YAAY,sCAAsC,EAAE","sourcesContent":["/* ==========================================\n   Kubersetu Premium Contact Page Styles\n   ========================================== */\n   \n:root {\n  --primary-amber: #f59e0b;\n  --primary-glow: rgba(245, 158, 11, 0.5);\n  --bg-dark: #0f172a;\n  --glass-bg: rgba(15, 23, 42, 0.55);\n  --glass-border: rgba(255, 255, 255, 0.08);\n  --text-main: #ffffff;\n  --text-muted: #94a3b8;\n}\n\n/* Background & Page Wrapper */\n.contact-page {\n  position: relative;\n  min-height: 100vh;\n  padding: 7.25rem 1.5rem 4rem 1.5rem;\n  background-color: var(--bg-dark);\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n/* Dynamic Background Orbs & Grid */\n.bg-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(120px);\n  z-index: 0;\n  opacity: 0.4;\n  animation: float 12s infinite alternate ease-in-out;\n}\n.orb-1 {\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(245,158,11,0.2) 0%, transparent 70%);\n  top: -10%;\n  left: -10%;\n}\n.orb-2 {\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%);\n  bottom: 0;\n  right: -5%;\n  animation-duration: 15s;\n  animation-direction: alternate-reverse;\n}\n\n.bg-grid {\n  position: absolute;\n  inset: 0;\n  background-image: \n    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);\n  background-size: 40px 40px;\n  z-index: 0;\n  pointer-events: none;\n}\n\n@keyframes float {\n  0% { transform: translate(0, 0) scale(1); }\n  100% { transform: translate(30px, 40px) scale(1.05); }\n}\n\n/* Glassmorphism Container */\n.contact-container {\n  position: relative;\n  z-index: 1;\n  max-width: 1100px;\n  width: 100%;\n  background: var(--glass-bg);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border-radius: 24px;\n  border: 1px solid var(--glass-border);\n  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255,255,255,0.1);\n  overflow: hidden;\n}\n\n/* Header */\n.contact-header {\n  padding: 4rem 2rem 2.5rem;\n  text-align: center;\n  position: relative;\n}\n\n.gradient-text {\n  font-size: clamp(2.5rem, 5vw, 3.5rem);\n  font-weight: 900;\n  background: linear-gradient(135deg, #fff 0%, #f59e0b 50%, #fbbf24 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1rem;\n  letter-spacing: -0.04em;\n  text-shadow: 0 10px 30px rgba(245,158,11,0.15);\n}\n\n.contact-header p {\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n/* Layout */\n.contact-content {\n  display: flex;\n  padding: 2rem 3rem 4rem;\n  gap: 4rem;\n  align-items: flex-start;\n}\n\n@media (max-width: 900px) {\n  .contact-content {\n    flex-direction: column;\n    padding: 2rem 1.5rem 3rem;\n    gap: 3rem;\n  }\n}\n\n/* Left Panel - Info */\n.contact-info {\n  flex: 0.9;\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-info h2 {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin-bottom: 1rem;\n  letter-spacing: -0.02em;\n}\n\n.contact-info > p {\n  color: var(--text-muted);\n  font-size: 1rem;\n  line-height: 1.7;\n  margin-bottom: 2.5rem;\n}\n\n.contact-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.25rem;\n  padding: 1.25rem;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 16px;\n  border: 1px solid transparent;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.contact-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(245, 158, 11, 0.2);\n  transform: translateX(8px);\n  box-shadow: 0 10px 20px rgba(0,0,0,0.1);\n}\n\n.contact-icon {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.05) 100%);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  color: var(--primary-amber);\n  flex-shrink: 0;\n  box-shadow: 0 4px 15px rgba(245,158,11,0.1);\n}\n\n.contact-text h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin-bottom: 0.35rem;\n}\n\n.contact-text p {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.contact-trust-card {\n  margin-top: 0;\n  background: linear-gradient(145deg, rgba(15, 23, 42, 0.8) 0%, rgba(30, 41, 59, 0.4) 100%);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 20px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.contact-trust-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: linear-gradient(90deg, transparent, rgba(245,158,11,0.05), transparent);\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.contact-trust-card:hover::before {\n  transform: translateX(100%);\n}\n\n.contact-trust-card .trust-icon {\n  font-size: 1.5rem;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 70px;\n  flex-shrink: 0;\n  background: rgba(245, 158, 11, 0.2);\n  border-radius: 16px;\n  box-shadow: inset 0 0 10px rgba(245,158,11,0.1);\n}\n\n.contact-trust-card h4 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--primary-amber);\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.01em;\n}\n\n.contact-trust-card p {\n  font-size: 0.95rem;\n  color: #cbd5e1;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.contact-trust-card strong {\n  color: #ffffff;\n  font-weight: 700;\n}\n\n/* Right Panel - Form Container */\n.contact-form-container {\n  flex: 1.1;\n  background: rgba(255, 255, 255, 0.03);\n  padding: 3rem;\n  border-radius: 24px;\n  border: 1px solid var(--glass-border);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255,255,255,0.05);\n  position: relative;\n}\n\n.form-title {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin-bottom: 0.5rem;\n}\n\n.form-subtitle {\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  margin-bottom: 2.5rem;\n}\n\n/* Floating Label Form Fields */\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 1.5rem;\n}\n\n@media (max-width: 600px) {\n  .form-row {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n}\n\n.form-group.floating {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.form-group.floating input,\n.form-group.floating textarea {\n  width: 100%;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.25rem 1.25rem 0.5rem;\n  font-size: 1rem;\n  color: var(--text-main);\n  font-family: inherit;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group.floating textarea {\n  padding-top: 1.75rem;\n  resize: vertical;\n}\n\n.form-group.floating label {\n  position: absolute;\n  top: 1rem;\n  left: 1.25rem;\n  font-size: 1rem;\n  color: var(--text-muted);\n  pointer-events: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transform-origin: left top;\n}\n\n.form-group.floating textarea ~ label {\n  top: 1rem;\n}\n\n/* Floating Label Animation */\n.form-group.floating input:focus ~ label,\n.form-group.floating input:not(:placeholder-shown) ~ label,\n.form-group.floating textarea:focus ~ label,\n.form-group.floating textarea:not(:placeholder-shown) ~ label {\n  transform: translateY(-0.5rem) scale(0.75);\n  color: var(--primary-amber);\n}\n\n/* Animated Bottom Border */\n.input-highlight {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 0;\n  background: var(--primary-amber);\n  transition: width 0.4s ease;\n  border-radius: 0 0 12px 12px;\n}\n\n.form-group.floating input:focus ~ .input-highlight,\n.form-group.floating textarea:focus ~ .input-highlight {\n  width: 100%;\n}\n\n.form-group.floating input:focus,\n.form-group.floating textarea:focus {\n  outline: none;\n  background: rgba(30, 41, 59, 0.8);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.error-text {\n  color: #ef4444;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n  font-weight: 500;\n}\n\n.input-error {\n  border-color: rgba(239, 68, 68, 0.5) !important;\n}\n\n/* Checkbox Styles */\n.checkbox-group {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  cursor: pointer;\n}\n\n.checkbox-container input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--primary-amber);\n  cursor: pointer;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.checkbox-label {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.checkbox-label strong {\n  color: var(--text-main);\n}\n\n/* Premium Submit Button */\n.submit-button {\n  position: relative;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: #fff;\n  padding: 1.1rem 2rem;\n  border-radius: 50px;\n  font-size: 1.05rem;\n  font-weight: 800;\n  border: none;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.3);\n  width: 100%;\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.submit-button .btn-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.submit-button .btn-icon {\n  font-size: 1.2rem;\n  transition: transform 0.3s ease;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.5);\n}\n\n.submit-button:hover:not(:disabled) .btn-icon {\n  transform: translate(3px, -3px);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Button Sweep Animation */\n.btn-glow {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);\n  transition: all 0.5s ease;\n  z-index: 1;\n}\n\n.submit-button:hover:not(:disabled) .btn-glow {\n  left: 100%;\n}\n\n/* Success Message */\n.success-message {\n  margin-top: 1.5rem;\n  padding: 1rem 1.5rem;\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #34d399;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.success-icon {\n  background: #10b981;\n  color: #0f172a;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  font-weight: 900;\n}\n\n/* FAQ Section */\n.faq-section {\n  padding: 4rem 3rem;\n  border-top: 1px solid var(--glass-border);\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.faq-section h2 {\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin-bottom: 3rem;\n  letter-spacing: -0.02em;\n}\n\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n@media (max-width: 768px) {\n  .faq-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n\n.faq-item {\n  background: rgba(255, 255, 255, 0.02);\n  padding: 2rem;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.hover-lift:hover {\n  transform: translateY(-6px);\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(245, 158, 11, 0.2);\n  box-shadow: 0 15px 30px rgba(0,0,0,0.2);\n}\n\n.faq-item h3 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-main);\n  margin-bottom: 0.75rem;\n  line-height: 1.4;\n}\n\n.faq-item p {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Animations (Classes to add dynamically or just use on mount) */\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeInLeft {\n  from { opacity: 0; transform: translateX(-40px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes fadeInRight {\n  from { opacity: 0; transform: translateX(40px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.fade-in-up { animation: fadeInUp 0.8s ease forwards; }\n.fade-in-left { animation: fadeInLeft 0.8s ease forwards; }\n.fade-in-right { animation: fadeInRight 0.8s ease forwards; }\n.slide-up { animation: fadeInUp 0.4s ease forwards; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
